import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import DashboardFooter from "./DashboardFooter";
import "../css/Staff.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaPlus,
  FaTrash,
  FaFilePdf,
  FaUpload,
  FaEye,
  FaEdit,
} from "react-icons/fa";

const API_URL = "https://auxititpt.org/Backend/notifications_api.php";
const PUBLIC_BASE = "https://localhost"; // used to prefix file_url stored by API

const StudentNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [viewing, setViewing] = useState(null);

  const [form, setForm] = useState({
    title: "",
    message: "",
    target_group: "All",
    status: "active",
    posted_by: "Admin",
    file: null,
  });

  useEffect(() => {
    fetchNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setNotifications(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Fetch notifications error:", err);
      alert("Failed to load notifications. Check console.");
      setNotifications([]);
    } finally {
      setLoading(false);
    }
  };

  const openAdd = () => {
    setForm({
      title: "",
      message: "",
      target_group: "All",
      status: "active",
      posted_by: "Admin",
      file: null,
    });
    setEditingId(null);
    setShowForm(true);
  };

  const openEdit = (n) => {
    setForm({
      title: n.title || "",
      message: n.message || "",
      target_group: n.target_group || "All",
      status: n.status || "active",
      posted_by: n.posted_by || "Admin",
      file: null, // file cannot be prefilled
    });
    setEditingId(n.id);
    setShowForm(true);
  };

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.title.trim() || !form.message.trim()) {
      alert("Title and Message are required");
      return;
    }

    const fd = new FormData();
    fd.append("title", form.title);
    fd.append("message", form.message);
    fd.append("target_group", form.target_group || "All");
    fd.append("status", form.status || "active");
    fd.append("posted_by", form.posted_by || "Admin");
    if (form.file) fd.append("file", form.file);

    const url = editingId ? `${API_URL}?id=${editingId}` : API_URL;

    try {
      const res = await fetch(url, {
        method: "POST",
        body: fd,
      });

      const result = await res.json();
      if (res.ok && result.status === "success") {
        alert(editingId ? "Notification updated" : "Notification added");
        setShowForm(false);
        setEditingId(null);
        setForm({
          title: "",
          message: "",
          target_group: "All",
          status: "active",
          posted_by: "Admin",
          file: null,
        });
        await fetchNotifications();
      } else {
        console.error("Submit error:", result);
        alert(result.message || "Operation failed");
      }
    } catch (err) {
      console.error("Submit exception:", err);
      alert("Error submitting notification. Check console.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this notification?")) return;
    try {
      const res = await fetch(`${API_URL}?id=${id}`, {
        method: "DELETE",
      });
      const result = await res.json();
      if (res.ok && result.status === "success") {
        alert("Notification deleted");
        await fetchNotifications();
      } else {
        console.error("Delete error:", result);
        alert(result.message || "Delete failed");
      }
    } catch (err) {
      console.error("Delete exception:", err);
      alert("Error deleting notification");
    }
  };

  const handleView = (n) => {
    setViewing(n);
  };

  return (
    <div className="student-notifications-page">
      <div className="d-flex dashboard-container">
        <Sidebar />
        <div className="main-content flex-grow-1">
          <Header />
          <div className="container py-5">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h3 className="fw-bold">Student Notifications</h3>
              <div className="d-flex gap-2">
                <button className="btn btn-outline-secondary" onClick={fetchNotifications}>
                  Refresh
                </button>
                <button className="btn btn-primary d-flex align-items-center" onClick={openAdd}>
                  <FaPlus className="me-2" /> Add Notification
                </button>
              </div>
            </div>

            {showForm && (
              <form className="card shadow p-4 mb-4" onSubmit={handleSubmit}>
                <h5 className="fw-bold mb-3 text-primary">
                  {editingId ? "Edit Notification" : "Add New Notification"}
                </h5>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Title *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={form.title}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Target Group</label>
                    <select
                      className="form-select"
                      name="target_group"
                      value={form.target_group}
                      onChange={handleChange}
                    >
                      <option value="All">All Students</option>
                      <option value="First Year">First Year</option>
                      <option value="Second Year">Second Year</option>
                      <option value="Welder">Welder</option>
                      <option value="Electrician">Electrician</option>
                    </select>
                  </div>

                  <div className="col-12">
                    <label className="form-label">Message *</label>
                    <textarea
                      className="form-control"
                      name="message"
                      rows="5"
                      value={form.message}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Attachment (PDF/JPG/PNG)</label>
                    <input
                      type="file"
                      className="form-control"
                      name="file"
                      onChange={handleChange}
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                    {editingId && form.file === null && (
                      <small className="text-muted">Leave blank to keep existing attachment</small>
                    )}
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      name="status"
                      value={form.status}
                      onChange={handleChange}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>

                  <div className="col-md-3 d-flex align-items-end">
                    <div>
                      <button type="submit" className="btn btn-success me-2">
                        {editingId ? "Update" : "Save"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowForm(false);
                          setEditingId(null);
                          setForm({
                            title: "",
                            message: "",
                            target_group: "All",
                            status: "active",
                            posted_by: "Admin",
                            file: null,
                          });
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            )}

            {/* Notifications Table */}
            <div className="card shadow">
              <div className="card-body">
                {loading ? (
                  <div className="text-center p-5">Loading...</div>
                ) : notifications.length === 0 ? (
                  <div className="text-center p-5 text-muted">No notifications found</div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered align-middle">
                      <thead className="table-dark text-center">
                        <tr>
                          <th>#</th>
                          <th>Title</th>
                          <th>Target</th>
                          <th>Status</th>
                          <th>Date</th>
                          <th>Attachment</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {notifications.map((n, i) => (
                          <tr key={n.id}>
                            <td>{i + 1}</td>
                            <td style={{ maxWidth: 300 }}>{n.title}</td>
                            <td>{n.target_group}</td>
                            <td>{n.status}</td>
                            <td>{n.created_at ? new Date(n.created_at).toLocaleString() : "—"}</td>
                            <td>
                              {n.file_url ? (
                                <a href={`${PUBLIC_BASE}${n.file_url}`} target="_blank" rel="noreferrer">
                                  <FaFilePdf /> View
                                </a>
                              ) : (
                                "—"
                              )}
                            </td>
                            <td className="text-center">
                              <button className="btn btn-sm btn-info me-1" onClick={() => handleView(n)}>
                                <FaEye />
                              </button>
                              <button className="btn btn-sm btn-warning me-1" onClick={() => openEdit(n)}>
                                <FaEdit />
                              </button>
                              <button className="btn btn-sm btn-danger" onClick={() => handleDelete(n.id)}>
                                <FaTrash />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>

            {/* View modal */}
            {viewing && (
              <div
                className="modal show d-block"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                onClick={() => setViewing(null)}
              >
                <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">{viewing.title}</h5>
                      <button type="button" className="btn-close" onClick={() => setViewing(null)}></button>
                    </div>
                    <div className="modal-body">
                      <p><strong>Message:</strong></p>
                      <p>{viewing.message}</p>
                      <p><strong>Target:</strong> {viewing.target_group}</p>
                      <p><strong>Status:</strong> {viewing.status}</p>
                      <p><strong>Posted by:</strong> {viewing.posted_by}</p>
                      <p><strong>Date:</strong> {viewing.created_at}</p>
                      {viewing.file_url && (
                        <p>
                          <strong>Attachment:</strong>{" "}
                          <a href={`${PUBLIC_BASE}${viewing.file_url}`} target="_blank" rel="noreferrer">
                            Open
                          </a>
                        </p>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button className="btn btn-secondary" onClick={() => setViewing(null)}>Close</button>
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>
          <DashboardFooter />
        </div>
      </div>
    </div>
  );
};

export default StudentNotifications;
